(async () => {
  const FALLBACK = {
    caption_delivering: 'Delivering to',
    caption_shopping_near: 'Shopping near',
    caption_unset: 'Delivering to',
    title_unset: 'Set your delivery address',
    error_address1: 'Enter a street address.',
    error_city: 'Enter a city.',
    error_province: 'Select a province.',
    error_postcode: 'Enter a 4-digit postcode.',
    error_not_found: "We couldn't find that address. Please check the street and postcode.",
    error_unserviceable: "We don't deliver to this area yet. Try another address.",
    error_location: "We couldn't get your location. You can enter your address instead."
  };

  let busy = false;
  let lastTrigger = null;

  function text(copy, key) {
    if (copy && copy[key]) return String(copy[key]);
    return FALLBACK[key] || '';
  }

  function decodeEntities(value) {
    return String(value)
      .replace(/&#(\d+);/g, (_, code) => String.fromCharCode(parseInt(code, 10)))
      .replace(/&#x([0-9a-f]+);/gi, (_, code) => String.fromCharCode(parseInt(code, 16)))
      .replace(/&quot;/g, '"')
      .replace(/&apos;/g, "'")
      .replace(/&gt;/g, '>')
      .replace(/&lt;/g, '<')
      .replace(/&amp;/g, '&');
  }

  function decodeJsonStrings(value) {
    if (typeof value === 'string') return decodeEntities(value);
    if (Array.isArray(value)) return value.map(decodeJsonStrings);
    if (value && typeof value === 'object') {
      const decoded = {};
      Object.keys(value).forEach((key) => {
        decoded[key] = decodeJsonStrings(value[key]);
      });
      return decoded;
    }
    return value;
  }

  function readJson(selector) {
    const el = document.querySelector(selector);
    if (!el) return null;
    try {
      return decodeJsonStrings(JSON.parse(el.textContent));
    } catch (err) {
      return null;
    }
  }

  function getCopy() {
    return readJson('[data-delivery-location-copy]') || {};
  }

  function trim(value) {
    if (value === undefined || value === null) return '';
    return String(value).trim();
  }

  function buildAddress(raw) {
    const source = raw || {};
    return {
      address1: trim(source.address1),
      address2: trim(source.address2),
      city: trim(source.city),
      province: trim(source.province),
      postal_code: trim(source.postal_code)
    };
  }

  function joinPlace(city, postal) {
    const cityText = city ? String(city) : '';
    const codeText = postal === undefined || postal === null ? '' : String(postal);
    if (cityText && codeText) return cityText + ', ' + codeText;
    return cityText || codeText;
  }

  function labelParts(session, copy) {
    const source = session && session.source ? String(session.source) : 'default';
    const address = session && session.address ? session.address : null;
    if (source === 'address' && address) {
      return {
        source: source,
        caption: text(copy, 'caption_delivering'),
        label: joinPlace(address.city, address.postal_code)
      };
    }
    if ((source === 'geo' || source === 'ip') && address && address.city) {
      return {
        source: source,
        caption: text(copy, 'caption_shopping_near'),
        label: String(address.city)
      };
    }
    return {
      source: source,
      caption: text(copy, 'caption_unset'),
      label: text(copy, 'title_unset')
    };
  }

  function revealBlocks() {
    document.querySelectorAll('[data-delivery-location-open]').forEach((el) => {
      el.hidden = false;
    });
  }

  function render(session) {
    try {
      window.__deliveryLocationLastSession = session || null;
      const parts = labelParts(session, getCopy());
      document.querySelectorAll('[data-delivery-caption]').forEach((el) => {
        el.textContent = parts.caption;
      });
      document.querySelectorAll('[data-delivery-label]').forEach((el) => {
        el.textContent = parts.label;
      });
      document.querySelectorAll('[data-delivery-location-open]').forEach((el) => {
        el.setAttribute('data-delivery-source', parts.source);
      });
      const statusCaption = document.querySelector('[data-delivery-status-caption]');
      const statusLabel = document.querySelector('[data-delivery-status-label]');
      if (statusCaption) statusCaption.textContent = parts.caption;
      if (statusLabel) statusLabel.textContent = parts.label;
    } catch (err) {}
  }

  function setExpanded(open, trigger) {
    document.querySelectorAll('[data-delivery-location-open]').forEach((el) => {
      el.setAttribute('aria-expanded', open && el === trigger ? 'true' : 'false');
    });
  }

  function focusTrigger() {
    const candidates = [];
    if (lastTrigger) candidates.push(lastTrigger);
    document.querySelectorAll('[data-delivery-location-open]').forEach((el) => {
      candidates.push(el);
    });
    for (let i = 0; i < candidates.length; i++) {
      if (candidates[i].getClientRects().length) {
        candidates[i].focus();
        return;
      }
    }
    if (lastTrigger) lastTrigger.focus();
  }

  function closeModal() {
    const modal = document.getElementById('modal-delivery-location');
    if (modal && modal.classList.contains('active') && typeof modal.hide === 'function') {
      modal.hide(false);
    }
    setExpanded(false);
    focusTrigger();
  }

  function formEl() {
    return document.querySelector('[data-delivery-address-form]');
  }

  function fieldEl(name) {
    const form = formEl();
    if (!form) return null;
    return form.querySelector('[name="' + name + '"]');
  }

  function clearErrors() {
    const formError = document.querySelector('[data-delivery-form-error]');
    if (formError) {
      formError.textContent = '';
      formError.hidden = true;
    }
    document.querySelectorAll('[data-error-for]').forEach((el) => {
      el.textContent = '';
      el.hidden = true;
    });
    const form = formEl();
    if (!form) return;
    form.querySelectorAll('[aria-invalid]').forEach((el) => {
      el.removeAttribute('aria-invalid');
      el.removeAttribute('aria-describedby');
    });
  }

  function showFormError(message) {
    const formError = document.querySelector('[data-delivery-form-error]');
    if (!formError) return;
    formError.hidden = false;
    formError.textContent = message;
  }

  function showFieldErrors(errors) {
    Object.keys(errors).forEach((name) => {
      const input = fieldEl(name);
      const message = document.querySelector('[data-error-for="' + name + '"]');
      if (message) {
        message.hidden = false;
        message.textContent = errors[name];
      }
      if (input) {
        input.setAttribute('aria-invalid', 'true');
        if (message && message.id) input.setAttribute('aria-describedby', message.id);
      }
    });
  }

  function focusFirstError(errors) {
    const order = ['address1', 'city', 'province', 'postal_code'];
    for (let i = 0; i < order.length; i++) {
      if (errors[order[i]]) {
        const input = fieldEl(order[i]);
        if (input) input.focus();
        return;
      }
    }
  }

  function validate(address, copy) {
    const errors = {};
    if (!address.address1) errors.address1 = text(copy, 'error_address1');
    if (!address.city) errors.city = text(copy, 'error_city');
    if (!address.province) errors.province = text(copy, 'error_province');
    if (!/^\d{4}$/.test(address.postal_code)) errors.postal_code = text(copy, 'error_postcode');
    return errors;
  }

  function hasErrors(errors) {
    return Object.keys(errors).length > 0;
  }

  function setProvince(value) {
    const select = fieldEl('province');
    if (!select) return;
    const next = value ? String(value) : '';
    let found = false;
    for (let i = 0; i < select.options.length; i++) {
      if (select.options[i].value === next) found = true;
    }
    select.value = found ? next : '';
  }

  function prefillForm(raw) {
    const address = buildAddress(raw);
    const names = ['address1', 'address2', 'city', 'postal_code'];
    names.forEach((name) => {
      const input = fieldEl(name);
      if (input) input.value = address[name];
    });
    setProvince(address.province);
  }

  function clearForm() {
    prefillForm({});
  }

  function readForm() {
    return buildAddress({
      address1: fieldEl('address1') ? fieldEl('address1').value : '',
      address2: fieldEl('address2') ? fieldEl('address2').value : '',
      city: fieldEl('city') ? fieldEl('city').value : '',
      province: fieldEl('province') ? fieldEl('province').value : '',
      postal_code: fieldEl('postal_code') ? fieldEl('postal_code').value : ''
    });
  }

  function currentSession() {
    if (window.__deliveryLocationLastSession) return window.__deliveryLocationLastSession;
    const PC = window.PantryClub;
    if (PC && typeof PC.getSession === 'function') {
      try {
        return PC.getSession();
      } catch (err) {
        return null;
      }
    }
    return null;
  }

  function syncFormToSession() {
    clearErrors();
    const session = currentSession();
    if (session && session.source === 'address' && session.address) {
      prefillForm(session.address);
    } else {
      clearForm();
    }
    document.querySelectorAll('[data-delivery-saved-option]').forEach((input) => {
      input.checked = false;
    });
  }

  function setWorking(selector, isWorking) {
    document.querySelectorAll(selector).forEach((el) => {
      el.disabled = isWorking;
      el.classList.toggle('working', isWorking);
      el.setAttribute('aria-busy', isWorking ? 'true' : 'false');
    });
    document.querySelectorAll('[data-delivery-submit], [data-delivery-use-location], [data-delivery-saved-option]').forEach((el) => {
      if (isWorking) el.disabled = true;
      else if (!el.matches(selector)) el.disabled = false;
    });
  }

  function refreshThemeCart() {
    if (typeof window.refreshCart !== 'function') return;
    if (!document.getElementById('AjaxCartForm')) return;
    try {
      window.refreshCart({ open: false });
    } catch (err) {}
  }

  function openModal(trigger) {
    lastTrigger = trigger;
    const sidebar = document.querySelector('.sidebar--opened');
    if (sidebar && typeof sidebar.hide === 'function') sidebar.hide();
    syncFormToSession();
    const modal = document.getElementById('modal-delivery-location');
    if (modal && typeof modal.show === 'function') modal.show();
    setExpanded(true, trigger);
  }

  async function commitAddress(address) {
    const PC = window.PantryClub;
    if (!PC || busy) return;
    if (typeof PC.checkAddress !== 'function' || typeof PC.setAddress !== 'function') return;
    const copy = getCopy();
    clearErrors();
    const errors = validate(address, copy);
    if (hasErrors(errors)) {
      showFieldErrors(errors);
      focusFirstError(errors);
      return;
    }
    busy = true;
    setWorking('[data-delivery-submit]', true);
    try {
      let preview;
      try {
        preview = await PC.checkAddress(address);
      } catch (err) {
        showFormError(text(copy, 'error_not_found'));
        return;
      }
      if (!preview || !preview.is_serviceable) {
        showFormError(text(copy, 'error_unserviceable'));
        return;
      }
      try {
        await PC.setAddress(preview.address || address);
      } catch (err) {
        showFormError(text(copy, 'error_not_found'));
        return;
      }
      closeModal();
      refreshThemeCart();
    } finally {
      busy = false;
      setWorking('[data-delivery-submit]', false);
    }
  }

  async function useLocation() {
    const PC = window.PantryClub;
    if (!PC || typeof PC.requestPreciseLocation !== 'function' || busy) return;
    busy = true;
    setWorking('[data-delivery-use-location]', true);
    clearErrors();
    try {
      await PC.requestPreciseLocation();
      closeModal();
    } catch (err) {
      showFormError(text(getCopy(), 'error_location'));
      const first = fieldEl('address1');
      if (first) first.focus();
    } finally {
      busy = false;
      setWorking('[data-delivery-use-location]', false);
    }
  }

  function onSavedPick(index) {
    const saved = readJson('[data-delivery-saved-addresses]');
    if (!saved || !saved[index]) return;
    const address = buildAddress(saved[index]);
    const errors = validate(address, getCopy());
    if (hasErrors(errors)) {
      prefillForm(address);
      showFieldErrors(errors);
      focusFirstError(errors);
      return;
    }
    commitAddress(address);
  }

  function bindOnce() {
    if (window.__deliveryLocationBound) return;
    window.__deliveryLocationBound = true;

    document.addEventListener('click', (event) => {
      try {
        const closer = event.target.closest('#modal-delivery-location [data-js-close]');
        if (closer) {
          setExpanded(false);
          focusTrigger();
          return;
        }
        const trigger = event.target.closest('[data-delivery-location-open]');
        if (trigger) {
          event.preventDefault();
          openModal(trigger);
          return;
        }
        const useButton = event.target.closest('[data-delivery-use-location]');
        if (useButton) {
          event.preventDefault();
          useLocation();
        }
      } catch (err) {}
    });

    document.addEventListener('keydown', (event) => {
      try {
        const trigger = event.target.closest('[data-delivery-location-open]');
        if (trigger && trigger.tagName !== 'BUTTON' && (event.key === 'Enter' || event.key === ' ')) {
          event.preventDefault();
          openModal(trigger);
        }
      } catch (err) {}
    });

    document.addEventListener('keydown', (event) => {
      if (event.key !== 'Escape' && event.keyCode !== 27) return;
      const modal = document.getElementById('modal-delivery-location');
      if (!modal || !modal.classList.contains('active')) return;
      window.setTimeout(() => {
        setExpanded(false);
        focusTrigger();
      }, 0);
    }, true);

    document.addEventListener('submit', (event) => {
      const form = event.target;
      if (!form || !form.hasAttribute || !form.hasAttribute('data-delivery-address-form')) return;
      event.preventDefault();
      try {
        commitAddress(readForm());
      } catch (err) {}
    });

    document.addEventListener('change', (event) => {
      const input = event.target;
      if (!input || !input.hasAttribute || !input.hasAttribute('data-delivery-saved-option')) return;
      try {
        clearErrors();
        onSavedPick(parseInt(input.getAttribute('data-delivery-saved-option'), 10));
      } catch (err) {}
    });

    document.addEventListener('input', (event) => {
      const input = event.target;
      if (!input || input.getAttribute('name') !== 'postal_code') return;
      if (!input.closest('[data-delivery-address-form]')) return;
      const cleaned = String(input.value).replace(/\D/g, '').slice(0, 4);
      if (cleaned !== input.value) input.value = cleaned;
    });

    document.addEventListener('shopify:section:load', () => {
      try {
        if (!window.PantryClub) return;
        revealBlocks();
        if (window.__deliveryLocationLastSession) render(window.__deliveryLocationLastSession);
      } catch (err) {}
    });
  }

  try {
    bindOnce();
    const PC = window.PantryClub;
    if (!PC || !PC.ready) return;
    if (window.__deliveryLocationListening) {
      const session = await PC.ready;
      revealBlocks();
      render(PC.getSession() || session);
      return;
    }
    window.__deliveryLocationListening = true;
    const session = await PC.ready;
    revealBlocks();
    render(PC.getSession() || session);
    PC.onSession(render);
  } catch (err) {}
})();
